import { useContext } from "react";
import sortBy from "lodash/sortBy";
import { useQuery } from "react-query";

import { useOrg } from "@hooks/useOrg";
import { PermissionsContext } from "@providers";

import { fetchActionsIfPermitted } from "@pages/settings/api";

/*
 * Returns query result with actions from current selected org sorted by id
 */
export const useActions = (onError?: (error: Error) => void) => {
  const org = useOrg();
  const { permissions } = useContext(PermissionsContext);

  return useQuery(
    ["actions", { org }],
    () =>
      fetchActionsIfPermitted(org?.id!, permissions).then((response) =>
        sortBy(response, (action) => action.id)
      ),
    {
      enabled: Boolean(org),
      onError,
    }
  );
};
